const satLibs = [
  "yahoo/yahoo-min.js",
  "jsrsasign/x509-1.1.js",
  "jsrsasign/asn1-1.0.js",
  "jsbn/jsbn.js",
  "jsbn/jsbn2.js",
  "jsbn/jsbn2.js",
  "asn1/asn1hex-1.1.js",
  "asn1/asn1.js",
  "asn1/base64.js",
  "jsrsasign/base64.js",
  "cryptojs/pbkdf2.js",
  "cryptojs/enc-base64.js",
  "rsa/rsa.js",
  "rsa/rsa2.js",
  "rsa/rsasign-1.2.js",
  "jsrsasign/crypto-1.1.js",
  "sjcl/sjcl.js",
  "cryptojs/tripledes.js",
];

const otherScripts = [
  "util.js",
  "debug.js",
  "jsbn.js",
  "oids.js",
  "asn1.js",
  "sha1.js",
  "sha256.js",
  "md5.js",
  "md.js",
  "prng.js",
  "random.js",
  "jsbn.js",
  "pkcs1.js",
  "rsa.js",
  "cipherModes.js",
  "cipher.js",
  "aes.js",
  "des.js",
  "rc2.js",
  "pbe.js",
  "pem.js",
  "hmac.js",
  "pbkdf2.js",
  "pkcs7.js",
  "pkcs7asn1.js",
  "pkcs12.js",
  "pss.js",
  "mgf1.js",
  "mgf.js",
  "x509.js",
  "pbkdf2.js",
  "pki.js",
];

const tiposDocumentosFirmas = {
  PROMOCION_INICIAL: 1,
  PROMOCION_TERMINO: 2,
  PROMOCION: 4,
  ACUERDO: 5,
  SENTENCIA: 6,
  PROMOCION_ELECTRONICA: 7,
  DEMANDA_ELECTRONICA: 8,
  PROMOCION_CENTRO_DE_CONVIVENCIA: 16,
  OFICIOS_EXPEDIENTE: 18,
  OFICIOS_GENERALES: 19,
  EXHORTO_GENERADO: 20,
  SOLICITUD_PROMOCION: 24,
  CERTIFICACION: 25,
  AUDIENCIA: 26,
  AUDIENCIA_EN_LINEA: 27,
  RESOLUCION_PUBLICA: 30,
  OFICIO_ENVIO_DE_REMESA: 33,
  OFICIO_DEVOLUCION_DEL_ARCHIVO: 34,
  REMESA: 36,
  OFICIOS_TESTAMENTARIO: 73,
  RESOLUCION_PUBLICA_INTRANET: 89,
  PROYECTO_DE_RESOLUCION_SI: 121,
  ACUERDO_DE_RADICACION: 124,
  ACUERDO_SI: 127,
  OFICIO_SI: 128,
  CERTIFICACION_SI: 129,
  AUDIENCIA_SI: 130,
  DILIGENCIA_SI: 131,
  EDICTO_SI: 132,
  NOTIFICACION_SI: 133,
};

export { satLibs, otherScripts, tiposDocumentosFirmas };
